module.exports = __webpack_public_path__ + "media/configurations/P-X-X-P-a8801b73.png";